<section class="text-center">
    <div class="container">
        <h2 class="width-650">
            Establish a <span class="text-line">robust</span> and sophisticated relationship between software and hardware communication. 
        </h2>
        <table class="table table-grid table-border align-center table-logos table-10">
            <tbody>
                <tr>
                    <td>
                        <i class="fab fa-html5"></i>
                    </td>
                    <td>
                        <i class="fab fa-css3-alt"></i>
                    </td>
                    <td>
                        <i class="fab fa-js"></i>
                    </td>
                    <td>
                        <i class="fab fa-angular"></i>
                    </td>
                    <td>
                        <i class="fab fa-python"></i>
                    </td>
                    <td>
                        <i class="fab fa-java"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</section>